<template>
  <div prop="variableArr" class="sky-server-config">
    <div
      :class="['sky-server-config__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择产品版本"
        v-model="item.productVersion"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        filterable
      >
        <el-option v-for="(item, index) in productList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择操作系统"
        v-model="item.os"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        filterable
      >
        <el-option v-for="(item, index) in osList" :key="index" :label="$t(item.label)" :value="item.id"> </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择兼容性"
        v-model="item.compatibleStatus"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        filterable
      >
        <el-option v-for="(item, index) in compatibleList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <el-input
        :ref="item.limitDesc"
        popper-class="sky-moudle-branch__autocomplete"
        class="sky-server-config__select"
        v-model="item.limitDesc"
        :placeholder="$t('若有条件兼容，请填写')"
      >
      </el-input>
      <i class="sk-icon-remove sk-font--B" v-if="index > 0" @click="handleDelete(index)"></i>
    </div>
    <div style="color: red;">{{ message }}</div>
    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加
    </el-button>
    <div style="text-align: center;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { COMMON_MNG, COLLECT_COMPAT } from '@/api/apiModules'
export default {
  name: 'SkyProductOsTypeRelate',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    row: {}
  },
  data() {
    return {
      loading: false,
      id: null,
      type: null,
      message: null,
      osList: [],
      productList: [],
      compatibleList: [],
      variableArr: [
        {
          productVersion: null,
          os: null,
          compatibleStatus: null,
          limitDesc: null
        }
      ]
    }
  },
  created() {},
  mounted() {
    this.id = this.row.id
    this.type = this.row.type
    this.osList = this.row.osType
      .split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .map(item => {
        return {
          id: item,
          label: item
        }
      })
    if (this.row.productVersion) {
      this.productList = this.row.productVersion
        .split(',')
        .filter((item, index, self) => self.indexOf(item) === index)
        .map(item => {
          return {
            id: item,
            label: item
          }
        })
    }
    action(COMMON_MNG, 'compatibleStatus').then(response => {
      this.compatibleList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
    })
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.productVersion && item.os && item.compatibleStatus
    },
    handleAdd() {
      this.variableArr.push({
        productVersion: null,
        os: null,
        limitDesc: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    },
    onConfirm() {
      if (this.variableArr.length) {
        for (const data of this.variableArr) {
          if (!this.isFill(data)) {
            this.message = '请输入未填项'
            return
          }
        }
      }
      const uploadCompat = {
        projectId: this.row.projectId,
        id: this.row.vId,
        type: this.row.type,
        compatibleInfoList: this.variableArr
      }
      action(COLLECT_COMPAT, 'uploadCompat', uploadCompat)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', { message: '兼容性上报成功', type: 'success' })
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
